import React, { useEffect, useMemo, useState } from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import TrendingSearchBlock from "./Generic/TrendingSearchBlock";
import { RecentSearch } from "./RecentSearch";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import { SearchAssetTypeEnum, dropDownCallPut } from "./constant";
import { getStockElement } from "./AllSearchDataBlock";
import searchDi from "./di/servicelocator";
import { Spinner } from "react-bootstrap";
import marginCalDi from "@frameworks/web/components/features/Tools/MarginCalculator/di/servicelocator";
import { getExpiryList } from "@domains/features/Markets/Options/mapper/expiryDateMapper";
import SearchDropdown from "./Generic/SearchDropdown";
import moment from "moment";
import _ from "underscore";
import { useNavigate } from "react-router-dom";
export const AssetTypeSwitch = (type) => {
    switch (type) {
        case SearchAssetTypeEnum.Equity:
            return "equities";
        case SearchAssetTypeEnum.Future:
            return "futures";
        case SearchAssetTypeEnum.Option:
            return "options";
        case SearchAssetTypeEnum.Commodity:
            return "commodities";
        case SearchAssetTypeEnum.Currency:
            return "currencies";
        case SearchAssetTypeEnum.ETFs:
            return "etfs";
        case SearchAssetTypeEnum.Indices:
            return "indicesList";
        case SearchAssetTypeEnum.NcdSecondary:
            return "ncdSecondaries";
        // case SearchAssetTypeEnum.SGB:
        //   return "sgbList";
        // case SearchAssetTypeEnum.CORPFD:
        //   return "corpFdList";
        case SearchAssetTypeEnum.PrimaryMarket:
            return "primaryMarket";
        case SearchAssetTypeEnum.ComFut:
            return "ComFut";
        case SearchAssetTypeEnum.ComOpt:
            return "ComOpt";
        case SearchAssetTypeEnum.MF:
            return "mutualFunds";
    }
};
const EquitySearchBlock = (props) => {
    var _a, _b, _c, _d, _e;
    const device = DeviceContext();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [loader, setLoader] = useState(false);
    const [strikePrice, setStrikePrice] = useState([]);
    const [expiryDates, setExpiryDates] = useState([]);
    const [selectedExpiry, setSelectedExpiry] = useState([]);
    const [selectedStrikePrice, setSelectedStrikePrice] = useState([]);
    const [selectOptionType, setSelectedOptionType] = useState([]);
    const trendingList = useMemo(() => {
        var _a, _b;
        if (((_a = props.trending) === null || _a === void 0 ? void 0 : _a.length) > 0)
            return (_b = props.trending) === null || _b === void 0 ? void 0 : _b.map((data) => {
                return getStockElement(data, navigate, props.closePopup, props === null || props === void 0 ? void 0 : props.setShowToc, props === null || props === void 0 ? void 0 : props.setSymbol, false, () => { }, props === null || props === void 0 ? void 0 : props.setShowMFToc);
            });
        else
            return React.createElement(Errormsg, { icon: "", msg: "No results found", showIcon: false });
    }, [props.trending]);
    const getAssetTypeSearch = (pageNumber) => {
        setLoader(true);
        setTimeout(() => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (((_a = props.search) === null || _a === void 0 ? void 0 : _a.length) > 2) {
                let filter = {
                    searchText: props.search,
                    pageNumber: pageNumber ? pageNumber : 1,
                };
                switch (props.type) {
                    case SearchAssetTypeEnum.Equity:
                        if (!props.filters.list.every((x) => x.selected)) {
                            // if both is seleted so no need pass value
                            (_b = props.filters) === null || _b === void 0 ? void 0 : _b.list.map((x) => {
                                if (x.selected) {
                                    filter.exchangeType = x.key;
                                }
                            });
                        }
                        break;
                    case SearchAssetTypeEnum.MF:
                        (_c = props.filters) === null || _c === void 0 ? void 0 : _c.list.map((x) => {
                            if (x.selected) {
                                filter.category = x.key;
                            }
                        });
                        break;
                    case SearchAssetTypeEnum.Option:
                        if ((selectedExpiry === null || selectedExpiry === void 0 ? void 0 : selectedExpiry.length) > 0)
                            filter.expiryDates = selectedExpiry === null || selectedExpiry === void 0 ? void 0 : selectedExpiry.join(",");
                        if ((selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.length) > 0)
                            filter.strikePrices = selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.join(",");
                        if ((selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.length) > 0)
                            filter.optionTypes = selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.join(",");
                        break;
                    case SearchAssetTypeEnum.Currency:
                        (_d = props.filters) === null || _d === void 0 ? void 0 : _d.list.map((x) => {
                            if (x.selected) {
                                filter.category = x.key;
                            }
                        });
                        if ((selectedExpiry === null || selectedExpiry === void 0 ? void 0 : selectedExpiry.length) > 0)
                            filter.expiryDates = selectedExpiry === null || selectedExpiry === void 0 ? void 0 : selectedExpiry.join(",");
                        if ((selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.length) > 0)
                            filter.strikePrices = selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.join(",");
                        if ((selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.length) > 0)
                            filter.optionTypes = selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.join(",");
                    case SearchAssetTypeEnum.ComOpt:
                        (_e = props.filters) === null || _e === void 0 ? void 0 : _e.list.map((x) => {
                            if (x.selected) {
                                filter.exchangeType = x.key;
                            }
                        });
                        if ((selectedExpiry === null || selectedExpiry === void 0 ? void 0 : selectedExpiry.length) > 0)
                            filter.expiryDates = selectedExpiry === null || selectedExpiry === void 0 ? void 0 : selectedExpiry.join(",");
                        if ((selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.length) > 0)
                            filter.strikePrices = selectedStrikePrice === null || selectedStrikePrice === void 0 ? void 0 : selectedStrikePrice.join(",");
                        if ((selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.length) > 0)
                            filter.optionTypes = selectOptionType === null || selectOptionType === void 0 ? void 0 : selectOptionType.join(",");
                        break;
                    case SearchAssetTypeEnum.ComFut:
                        if (!props.filters.list.every((x) => x.selected))
                            (_f = props.filters) === null || _f === void 0 ? void 0 : _f.list.map((x) => {
                                if (x.selected) {
                                    filter.exchangeType = x.key;
                                }
                            });
                    case SearchAssetTypeEnum.PrimaryMarket:
                        if (!props.filters.list.every((x) => x.selected)) {
                            let marketType = [];
                            (_g = props.filters) === null || _g === void 0 ? void 0 : _g.list.map((x) => {
                                if (x.selected) {
                                    marketType.push(x.key);
                                }
                            });
                            filter.marketType = marketType.join(",");
                        }
                        break;
                    default:
                        break;
                }
                searchDi.search
                    .getAssetTypeSearch(props.type, filter)
                    .then((data) => {
                    if (pageNumber) {
                        setData((da) => {
                            return Object.assign(Object.assign({}, data), { [AssetTypeSwitch(props.type)]: [
                                    ...data[AssetTypeSwitch(props.type)],
                                    ...da[AssetTypeSwitch(props.type)],
                                ] });
                        });
                    }
                    else {
                        setData(data);
                    }
                })
                    .catch((error) => console.log(error))
                    .finally(() => {
                    setLoader(false);
                });
            }
        }, 500);
    };
    useEffect(() => {
        getAssetTypeSearch();
    }, [
        JSON.stringify((_a = props.filters) === null || _a === void 0 ? void 0 : _a.list),
        selectedExpiry,
        selectedStrikePrice,
        selectOptionType,
    ]);
    const handleScroll = (e) => {
        const bottom = Math.floor(e.currentTarget.scrollHeight - e.currentTarget.scrollTop) ===
            Math.floor(e.currentTarget.clientHeight);
        let load = loader;
        let nextPage = data === null || data === void 0 ? void 0 : data.nextPage;
        let last = data === null || data === void 0 ? void 0 : data.last;
        setData((da) => {
            nextPage = da === null || da === void 0 ? void 0 : da.nextPage;
            last = da === null || da === void 0 ? void 0 : da.last;
            return da;
        });
        setLoader((D) => {
            load = D;
            return D;
        });
        if (bottom && data && !last && !load && nextPage) {
            getAssetTypeSearch(nextPage);
        }
    };
    React.useEffect(() => {
        let modal;
        if (device === null || device === void 0 ? void 0 : device.isMobile) {
            modal = document.getElementsByClassName("search-search-bar-mobile");
        }
        else {
            modal = document.getElementsByClassName("modal-body");
        }
        if (modal && modal.length > 0) {
            modal[0].addEventListener("scroll", (e) => handleScroll(e), {
                passive: true,
            });
        }
        return () => {
            if (modal && modal.length > 0) {
                modal[0].addEventListener("scroll", (e) => handleScroll(e));
            }
        };
    }, [data, loader, props.type]);
    const getStrikePriceList = (expDate) => {
        let req = {
            und: props.selectedOption.underlyingSymbolName,
            ins: props.selectedOption.instrumentType,
            optionType: "CE",
        };
        setStrikePrice([]);
        expDate.map((ex) => {
            req.date = moment(ex).format("YYYY-MM-DD");
            marginCalDi.marginCalculator.getStrikePriceList(req).then((data) => {
                var _a;
                if (((_a = data.strikePriceList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    setStrikePrice((c) => {
                        return _.uniq([
                            ...c,
                            ...data.strikePriceList.map((x) => {
                                return {
                                    display: x,
                                    value: x,
                                };
                            }),
                        ], "value");
                    });
                }
            });
        });
    };
    useEffect(() => {
        if (props === null || props === void 0 ? void 0 : props.selectedOption) {
            marginCalDi.marginCalculator.getExpiryDate().then((data) => {
                setExpiryDates(getExpiryList(data.data.validExpiry, props.selectedOption.instrumentType, "OPTSTK0").map((x, i) => {
                    // if (i === 0) {
                    //   setSelectedExpiry(x);
                    //   getStrikePriceList(x); // for default select expiry date and get strikeprice list
                    // }
                    return {
                        display: x,
                        value: x,
                    };
                }));
            });
        }
    }, [props.selectedOption]);
    const optionsFilters = useMemo(() => {
        var _a, _b, _c;
        return (props.type === SearchAssetTypeEnum.Option ||
            ((_c = (_b = (_a = props.filters) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.find((x) => x.key === "OPT")) === null || _c === void 0 ? void 0 : _c.selected));
    }, [props.type, JSON.stringify((_b = props.filters) === null || _b === void 0 ? void 0 : _b.list)]);
    return (React.createElement(React.Fragment, null, ((_c = props.search) === null || _c === void 0 ? void 0 : _c.length) > 2 ? (React.createElement("div", { className: `equity-search-block  pdt-20 ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "" : "pdlr-15"}` },
        optionsFilters && (React.createElement("div", { className: "pb-4 d-flex gap-20" },
            React.createElement(SearchDropdown, { list: expiryDates, name: "expiry", selected: selectedExpiry, onChange: (e) => {
                    setSelectedExpiry((ex) => {
                        let exp = [...ex];
                        const index = exp === null || exp === void 0 ? void 0 : exp.findIndex((z) => z === e.target.value);
                        if (e.target.checked && index === -1) {
                            exp.push(e.target.value);
                        }
                        else {
                            exp.splice(index, 1);
                        }
                        getStrikePriceList(exp);
                        return exp;
                    });
                }, title: "Select Expiry" }),
            React.createElement(SearchDropdown, { list: strikePrice.sort((a, b) => +a.value - +b.value), name: "strikeprice", selected: selectedStrikePrice, onChange: (e) => {
                    setSelectedStrikePrice((sp) => {
                        let strike = [...sp];
                        const index = strike === null || strike === void 0 ? void 0 : strike.findIndex((z) => z === e.target.value);
                        if (e.target.checked && index === -1) {
                            strike.push(e.target.value);
                        }
                        else {
                            strike.splice(index, 1);
                        }
                        return strike;
                    });
                }, title: "Select Strike Price" }),
            React.createElement(SearchDropdown, { list: dropDownCallPut, name: "optiontype", selected: selectOptionType, onChange: (e) => {
                    setSelectedOptionType((opType) => {
                        let type = [...opType];
                        const index = type === null || type === void 0 ? void 0 : type.findIndex((z) => z === e.target.value);
                        if (e.target.checked && index === -1) {
                            type.push(e.target.value);
                        }
                        else {
                            type.splice(index, 1);
                        }
                        return type;
                    });
                }, title: "Select Option Type" }))),
        React.createElement("div", { className: `searchdata-border-block ` }, data && ((_d = data[AssetTypeSwitch(props.type)]) === null || _d === void 0 ? void 0 : _d.length) > 0 ? (React.createElement(React.Fragment, null, (_e = data[AssetTypeSwitch(props.type)]) === null || _e === void 0 ? void 0 :
            _e.map((item) => {
                var _a, _b;
                if (props.type === SearchAssetTypeEnum.Option) {
                    item = Object.assign(Object.assign({}, item), { idx: (_a = props === null || props === void 0 ? void 0 : props.selectedOption) === null || _a === void 0 ? void 0 : _a.idx, instrumentType: (_b = props.selectedOption) === null || _b === void 0 ? void 0 : _b.instrumentType });
                }
                return getStockElement(item, navigate, props.closePopup, props.setShowToc, props.setSymbol, false, () => { }, props.setShowMFToc);
            }),
            loader && (React.createElement("div", { className: "d-flex align-item-center justify-content-center" },
                React.createElement(Spinner, { animation: "border", role: "status" },
                    React.createElement("span", { className: "visually-hidden" }, "Loading...")))))) : loader ? (React.createElement("div", { className: "d-flex align-item-center justify-content-center" },
            React.createElement(Spinner, { animation: "border", role: "status" },
                React.createElement("span", { className: "visually-hidden" }, "Loading...")))) : (React.createElement(Errormsg, { icon: "", msg: "No results found", showIcon: false }))))) : (React.createElement(React.Fragment, null,
        React.createElement(TrendingSearchBlock, { content: trendingList }),
        React.createElement(RecentSearch, { type: props.recentType, list: props.recentSearch, closePopup: props.closePopup, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol, setShowMFToc: props === null || props === void 0 ? void 0 : props.setShowMFToc })))));
};
export default EquitySearchBlock;
